import { useCallback, useState } from 'react';
import { useResizeObserver } from '@/hooks';
import { getToolkitGridCollapsedLimit } from '../utils/getToolkitGridColumnCount';

export function useToolkitGridCollapsedLimit(compact: boolean) {
  const [containerElement, setContainerElement] = useState<HTMLElement | null>(null);
  const [collapsedLimit, setCollapsedLimit] = useState(() => getToolkitGridCollapsedLimit(0, compact));

  const handleResize = useCallback<ResizeObserverCallback>(
    (entries) => {
      const width = entries[0]?.contentRect.width ?? 0;
      setCollapsedLimit(getToolkitGridCollapsedLimit(width, compact));
    },
    [compact],
  );

  useResizeObserver(containerElement, undefined, handleResize);

  return { containerRef: setContainerElement, collapsedLimit };
}
